export function makeTxtOverFLow(str, len) {
   if (!str)
      return ""

   if (str?.length <= len)
      return str;

   return str?.slice(0, len) + "....";
}

export function getSrchTypeTxt(ddArr, searchType) {
   let filteredObj = ddArr.filter((i) => i.value === searchType);
   return filteredObj[0]?.label || "";
}

export function formatName(fName, lName) {
   if (fName && lName)
      return capFirstLetterOnly(`${fName} ${lName}`);
   if (fName)
      return capFirstLetterOnly(fName);
   return "";
}

export function capFirstLetterOnly(string) {
   if (string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
   }
   return ""
}

export function getFirstLetter(string) {
   if (string) {
      return string.charAt(0).toUpperCase();
   }
   return ""
}

export function formatPoProdStatus(status) {
   switch (status) {
      case "awaiting_post_po_clarify": return "AWAITING POST-PO CLARIFICATION";
      case "packing_in_prog": return "PACKING IN PROGRESS";
      case "back_order": return "BACK ORDER";
      case "partially_del": return "PARTIALLY DELIVERED";
      case "del_completed": return "DELIVERY COMPLETED";
      default: return status
   }
}

export function NumberFormatter(num) {
   if (num === "" || num === null || num === "null")
      return "NA"
   try {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
   } catch (error) {
      return num
   }
}

export function formatDateWithJs(dateTime) {
   if (!dateTime)
      return 'NA'

   if (dateTime === "null")
      return 'NA'

   //18/9/2022
   var date = new Date(dateTime);
   let month = date.getMonth() + 1;

   return (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + '-'
      + (month < 10 ? "0" + month : month) + "-"
      + date.getFullYear()
}


export function convert10(num) {
   if (num === "1" || num === 1)
      return "YES";
   else if (num === "0" || num === 0)
      return "NO";
   else
      return num;
}

export function datePickerformat(dateTime) {
   if (!dateTime)
      return null

   //18/9/2022  yyyy-MM-dd
   var date = new Date(dateTime);
   let month = date.getMonth() + 1;

   return date.getFullYear() + "-" +
      (month < 10 ? "0" + month : month) + "-" +
      (date.getDate() < 10 ? "0" + date.getDate() : date.getDate())
}

export function isEmpty(val) {
   if (val === "" || val === null || val === undefined)
      return true

   return false
}

export function isNotEmpty(val) {
   if (val === "" || val === null || val === undefined)
      return false

   return true
}

export function checkNumFormat(val) {
   if (val === "" || val === undefined)
      return null

   return parseInt(val)

}

export function formatDoPymtStatus(status) {
   switch (status) {
      case "paid": return "PAID";
      case "unpaid": return "UNPAID";
      case "partially_paid": return "PARTIALLY PAID";
      case "na": return "NA";
      case null: return "NA";
      case "": return "NA"
      default: return status
   }
}